import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppService } from '@services/app';
import { getBaseUrl } from '@store/selectors/features/app';
import { EVENT_LOGS_ON_SERVER, FETCH_CURRENCIES, FETCH_FAQS, FETCH_SUGGESTED_QUESTION } from '../action-types';
import { showAlert } from '../slices/features';
import { TOAST_VARIANT } from '@root/constants';
import { t } from "i18next";

const appService = new AppService();

export const fetchSuggestedQuestions = createAsyncThunk<
  TObject,
  TObject,
  IActionOptions
>(
  FETCH_SUGGESTED_QUESTION,
  async (requestPayload: any, thunkAPI) => {
    const { sucessCallback, failureCallback } = requestPayload;

    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const { data } = await appService.fetchSuggestedQuestions(baseUrl);
      if (typeof sucessCallback === 'function') {
        sucessCallback(data?.rows);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchFaqs = createAsyncThunk<
  TObject,
  TObject,
  IActionOptions
>(
  FETCH_FAQS,
  async (requestPayload: allAnyTypes, thunkAPI) => {
    const { sucessCallback, failureCallback, page = 1, pageSize = 10 } = requestPayload;

    const payload = {
      page,
      limit: pageSize,
    }

    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const response = await appService.fetchFaqs(baseUrl, payload);
      if (typeof sucessCallback === 'function') {
        sucessCallback(response);
      }
      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error);
      }

      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const logEventOnServer: any = createAsyncThunk(
  EVENT_LOGS_ON_SERVER,
  async (requestPayload: any, thunkAPI: any) => {
    const baseUrl = getBaseUrl(thunkAPI.getState());
    const { data, error } = await appService.logEvent(baseUrl, requestPayload);

    if (error) {
      thunkAPI.dispatch(
        showAlert({
          message:
            data?.message ||
            data?.userMessage ||
            data?.code ||
            t("common:feedback.somethingWrong"),
          type: TOAST_VARIANT.ERROR,
        })
      );
      return thunkAPI.rejectWithValue(data);
    } else {
      return thunkAPI.fulfillWithValue(data);
    }
  }
);
